import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { usePortalLanguage } from '../hooks/usePortalLanguage';

export default function PortalAutoLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = usePortalLanguage();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    if (!token) { setError('invalidLink'); return; }

    api.post('/portal/session', { token })
      .then(() => {
        navigate('/portal/dashboard', { replace: true });
      })
      .catch(() => setError('autoLoginFailed'));
  }, []); // eslint-disable-line

  if (error) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <p className="text-red-500 text-sm mb-4">{t(`login.${error}`)}</p>
        <a href="/portal" className="text-purple-600 text-sm underline">{t('login.gotoLogin')}</a>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-purple-600 border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-sm text-gray-500">{t('login.autoLoggingIn')}</p>
      </div>
    </div>
  );
}
